import { isDisableViewingTimeMetrics } from './isEnabled'

export default isDisableViewingTimeMetrics
